import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import {
  DotsThreeVerticalIcon,
  MinusCircleIcon,
  SealCheckIcon,
  EnvelopeSimpleIcon
} from "@phosphor-icons/react";
import Icon from "components/Icon/Icon";
import {
  RowActionsMenuWrapper,
  RowActionConatiner
} from "pages/TalentAgencies/AgencyPage/styled";

import UserActivateModal from "../Modals/UserActivateModal/index";

const MENU_WIDTH = 164;

const ActionDropdown = ({ userInfo }) => {
  const [open, setOpen] = useState(false);
  const [ready, setReady] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const [showActivateModal, setShowActivateModal] = useState(false);
  const [currentStatus, setCurrentStatus] = useState("");

  const triggerRef = useRef(null);
  const menuRef = useRef(null);

  useEffect(() => {
    if (menuRef.current) {
      menuRef.current.style.width = `${MENU_WIDTH}px`;
    }
  }, [menuRef.current, open]);

  // Open menu with position calculated first (NO JERK)
  const handleOpen = () => {
    if (!triggerRef.current) return;

    const rect = triggerRef.current.getBoundingClientRect();

    setPosition({
      top: rect.bottom + window.scrollY + 0,
      left: rect.right + window.scrollX - MENU_WIDTH // align left
    });

    setReady(true);
    setOpen(true);
  };

  // Close helper
  const closeMenu = () => {
    setOpen(false);
    setReady(false);
  };

  // Outside click close
  useEffect(() => {
    if (!open) return;

    const handleClickOutside = (e) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(e.target) &&
        !triggerRef.current.contains(e.target)
      ) {
        closeMenu();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  const updateDropdownStatus = (status) => {
    setCurrentStatus(status);
    setShowActivateModal(true);
  };
  //   Trigger (inside table)
  return (
    <>
      <RowActionConatiner className="row-action-dropdown">
        <div ref={triggerRef} className="dropdowm-toggle" onClick={handleOpen}>
          <Icon component={DotsThreeVerticalIcon} size={20} />
        </div>

        {/* Portal Menu */}
        {open &&
          ready &&
          ReactDOM.createPortal(
            <RowActionsMenuWrapper
              ref={menuRef}
              className="row-action-menu"
              style={{
                position: "absolute",
                top: position.top,
                left: position.left
              }}
            >
              {userInfo.status === "not_filled" && (
                <div
                  className="menu-item"
                  onClick={() => updateDropdownStatus(userInfo.status)}
                >
                  <Icon component={EnvelopeSimpleIcon} size={14} />
                  Add Email & Activate
                </div>
              )}

              {(userInfo.status === "pending_approval" ||
                userInfo.status === "deactivated") && (
                <div
                  className="menu-item"
                  onClick={() => updateDropdownStatus("activated")}
                >
                  <Icon component={SealCheckIcon} size={14} />
                  Activate
                </div>
              )}

              {(userInfo.status === "pending_approval" ||
                userInfo.status === "activated") && (
                <div
                  className="menu-item"
                  onClick={() => updateDropdownStatus("deactivated")}
                >
                  <Icon component={MinusCircleIcon} size={14} />
                  Deactivate
                </div>
              )}
            </RowActionsMenuWrapper>,
            document.body
          )}
      </RowActionConatiner>

      <UserActivateModal
        show={showActivateModal}
        onHide={() => setShowActivateModal(false)}
        userInfo={userInfo}
        updateType="usersList"
        currentStatus={currentStatus}
      />
    </>
  );
};

export default ActionDropdown;
